export const DIRECTORY_SERVICE_OFFERING_CLICK = 'directory_service_offering_click';
export const DIRECTORY_PROVIDER_CLICK = 'directory_provider_click';
export const MODALITY_LANDING_PAGE_SERVICE_OFFERING_CLICK = 'modality_landing_page_service_offering_click';
export const CONNECT_ME_BUTTON_CLICK = 'connect_me_button_click';